import { Link, usePage } from "@inertiajs/react";
import { useMemo, useEffect, useState } from "react";

function Header() {
  const { name, homeUrl, logo, menus } = usePage().props.wp;
  const headerMenu = useMemo(() => menus?.["header-menu"] ?? null, [menus]);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header>
      <div
        className={`card-16-equal md:card-24-equal  ${
          scrolled
            ? "!bg-white !py-[12px] md:!py-[16px] h-[60px] md:h-[74px] !rounded-t-none "
            : ""
        }`}
      >
        <div className="mx-auto h-full grid grid-cols-2 md:grid-cols-3 justify-between gap-2 md:gap-4 items-center">
          <div className="flex items-center h-full">
            <Link href={homeUrl} className="block h-full">
              {logo ? (
                <img
                  src={logo.sizes.large.url}
                  alt={logo.metadata.alt}
                  className="h-full w-full object-contain"
                />
              ) : (
                <p className="text-lg md:text-xl font-bold">{name}</p>
              )}
            </Link>
          </div>
          <nav className="w-full hidden md:flex items-center justify-center ">
            {headerMenu && (
              <ul
                id="header-menu"
                className="flex items-center space-x-4 md:space-x-6"
              >
                {headerMenu.items.map((item) => (
                  <li
                    key={item.id}
                    className="text-sm md:text-base font-medium"
                  >
                    {item.type === "custom" ? (
                      <a
                        href={item.url}
                        target="_blank"
                        className="hover:text-primary transition-colors"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        href={item.url}
                        className="hover:text-primary transition-colors"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </nav>
          <div className="hidden md:flex items-center gap-2 justify-end">
            <button className="text-primary text-sm md:text-base">test</button>
            <button className="text-primary text-sm md:text-base">test</button>
          </div>
          <div className="flex md:hidden items-center gap-2 justify-end">
            <button className="text-secondary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5 md:size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
